import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/layout/page-container';
import { PageHeader } from '@/components/layout/page-header';
import { SuggestFeatureForm } from './-components/suggest-feature-form';

export const Route = createFileRoute('/_authenticated/_global/feature-request/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageContainer>
      <div className="max-w-2xl mx-auto">
        <PageHeader
          title="Suggest a Feature"
          description="Help us improve by suggesting new features or enhancements"
        />

        <div className="mt-8">
          <SuggestFeatureForm />
        </div>
      </div>
    </PageContainer>
  );
}
